<template>
    <div>        
        <div class="request_changesec" v-if="!serviceRequest"> 
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-11">  
                    <div class="compose_mailsec">
                        <app-profile :ticketFilter="ticketReasonList[loadServiceRequest]"  :ticketRequest="ticketRequestFrom" :accountIdFrom="account_id" ></app-profile>
                    </div>                  
                </div> 
            </div> 
        </div>
        <div class="main_inner_section services_request" v-else>
            <div class="support_search row d-flex align-items-center justify-content-center mb-3 pt-4 pb-2"> 
                <div class="col-6 text-center">
                    <h2 class="support_title mb-4">{{$t('helpSupport')}}</h2>
                    <div class="form-group field-wrapper">
                        <input type="text" class="form-control input_search inputs" id="myInput" name="" :placeholder="$t('SearchSomething')" v-on:keyup="keymonitor">
                        <input type="submit" class="pos_ab" value="search" name="">
                    </div>
                </div>  
            </div>
            <div id="major_service_sec" class="outer_major_sersec">
                <ul class="inner_dropdown request_lisec mb-5" id="myUL">  
					<li v-for="list in ticketData[-1]" v-if="parseInt(ticketReasonList[list].status) == 1 && parseInt(ticketReasonList[list].tickets) == 1">
                        <div> 
                        <a href="javascript:void(0)" v-on:click.prevent="enableRequestElement(list, ticketReasonList[list].title)">
                            <div class="icon">
                                <img :src="'../../../../static/fxView/images/'+iconFile[list].icon" alt="Email Support" v-if="iconFile[list]">
                                <img :src="'../../../../static/fxView/images/sr_others.png'" alt="Email Support" v-else>
                            </div>
                            <h6 v-if="iconFile[list]">{{ $t(iconFile[list].lang) }}</h6>
                            <h6 v-else>{{ ticketReasonList[list].title }}</h6>
                        </a>
                        </div>
                    </li>
                    <div class="col-12 noRecordFound" v-if="showNoRecordFound">
                        <img
                            src="../../../../static/fxView/images/search.svg"
                            alt="no record found"
                        />
                        <p>{{ $t("thereIsNoRecord") }}</p>
                    </div>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>      
    import { fxViewMixins } from '@/plugins/fxView'  
    import profileRequest from './services/profile_request'
    export default {
        name: 'SERVICES',
        mixins: [fxViewMixins],
        data () {
          return {
            pageTitle : this.$options.name,
			iconFile :{ 
                '1': {'icon':  'sr_profile.png','title': "Profile",'lang':'profile'},
                '2': {'icon': 'sr_tradingaccount.png' , 'title': "Trading Account",'lang':'tradingAcc'},
				'3': {'icon':  'otherTicket.svg' , 'title': "PAMM Requests",'lang':''},
                '4': {'icon':  'otherTicket.svg' , 'title': "IB Requests",'lang':''},
                '5': {'icon':  'sr_deposit.png' , 'title': "Deposits",'lang':'Deposits'},
                '6': {'icon':  'sr_withdrawals.png' , 'title': "Withdrawals",'lang':'Withdrawals'},
				'7': {'icon':  'sr_bonus.png' , 'title': "Bonus",'lang':''},
                '8': {'icon':  'sr_vps.png' , 'title': "VPS",'lang':'VPS'},
				'9': {'icon':  'sr_reimbursement.png', 'title': "Reimbursement",'lang':''},
                '10': {'icon':  'sr_complaints.png' , 'title': "Complaints",'lang':'Complaints'},
				'11': {'icon': 'sr_compliance.png' , 'title': "Compliance",'lang':''},
                '12': {'icon': 'sr_feedback.png' , 'title': "Feedback",'lang':'Feedback'},
                '13': {'icon': 'sr_others.png' , 'title': "Others",'lang':'Others'},
                '16': {'icon': 'sr_addpayment.png', 'title': "Add Payment Method",'lang':'AddPaymentMethod'},
				'91': {'icon': 'otherTicket.svg', 'title': "Registeration Documents",'lang':''},
                '92': {'icon': 'otherTicket.svg', 'title': "Skip Documents",'lang':''},
				'94': {'icon': 'otherTicket.svg', 'title': "Become A Pro",'lang':''}
            },
            loadServiceRequest : "",
            serviceRequest : true,
            

            //come request from deposit----
            ticketRequestFrom : '',
            account_id : '',
            method_id : '',
			inList_custom_id : '',
			
			showDiv : '1',
			reason : '',
			reason_text : '',
			title : '0',
			title_text : '',
			info_req : '',
            showNoRecordFound : false,
          }
        }, 
        components: {
            appProfile: profileRequest
        },
		
        methods: {
			keymonitor(){
				var input, filter, ul, li, a, i, txtValue;
                  input = document.getElementById('myInput');
                  filter = input.value.toUpperCase();
                  ul = document.getElementById("myUL");
                  li = ul.getElementsByTagName('li');
                  let dispalyCount = 0;
                  // Loop through all list items, and hide those who don't match the search query
                  for (i = 0; i < li.length; i++) {
                    a = li[i].getElementsByTagName("a")[0];
                   
                    txtValue = a.textContent || a.innerText;
                    
                    if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        dispalyCount += 1;
                        this.showNoRecordFound = false;
                        li[i].style.display = "";
                    } else {
                      li[i].style.display = "none";
                    }
                  }
                  if (dispalyCount === 0) {
                    this.showNoRecordFound = true;
                  }
			},
            enableRequestElement(elementName, name){
                switch (name) {
                case 'Profile':
                    this.$trackEvent('CP+Support+Ticket+Profile');
                    break;
                case 'Trading Account':
                    this.$trackEvent('CP+Support+Ticket+Trading+Accounts');
                    break;
                case 'Deposits':
                    this.$trackEvent('CP+Support+Ticket+Deposits');
                    break;
                case 'Deposit Alert':
                    this.$trackEvent('CP+Support+Ticket+Deposit+Alert');
                    break;
                case 'VPS':
                    this.$trackEvent('CP+Support+Ticket+VPS');
                    break;
                case 'Feedback':
                    this.$trackEvent('CP+Support+Ticket+Feedback');
                    break;
                case 'Others':
                    this.$trackEvent('CP+Support+Ticket+others');
                    break;
                case 'Increase Crypto Limit':
                    this.$trackEvent('CP+Support+Ticket+Increase+Crypto+Limit');
                    break;
                case 'ZULU':
                    this.$trackEvent('CP+Support+Ticket+Zulu');
                    break;
                case 'MQL5':
                    this.$trackEvent('CP+Support+Ticket+MQL5');
                    break;
                case 'DEPOSIT BONUS':
                    this.$trackEvent('CP+Support+Ticket+Deposit+Bonus');
                    break;
                case 'Refer a Friend':
                    this.$trackEvent('CP+Support+Ticket+Refer+a+Friend');
                    break;
                case 'Wallet':
                    this.$trackEvent('CP+Support+Ticket+Wallet');
                    break;
                case 'Enable Islamic account':
                    this.$trackEvent('CP+Support+Ticket+Islamic+Account');
                    break;
                case 'Add Payment Method':
                    this.$trackEvent('CP+Support+Ticket+add+Payment+Method');
                    break;
                case 'Withdrawals':
                    this.$trackEvent('CP+Support+Ticket+Withdrawals');
                    break;
                }  
				this.loadServiceRequest =  elementName
				if(!parseInt(this.ticketReasonList[this.loadServiceRequest].infomration_req) || (parseInt(this.loadServiceRequest) == 16 && this.method_id != '')){
					this.showDiv = '3'
					if(parseInt(this.loadServiceRequest) == 16){
						this.chooseRequestType(this.inList_custom_id,this.ticketReasonList[this.loadServiceRequest])
					}else{
						this.chooseRequestType('',this.ticketReasonList[this.loadServiceRequest])
					}
				}else{
                    this.showDiv = '1'
                }
				this.serviceRequest = false
            },
			chooseRequestType(getInlistId,getOutListData){
                this.reason = getOutListData.id
                this.reason_text = getOutListData.title
				this.title = '0'
                this.title_text = '' 
				if(getInlistId != '' && getInlistId != null){
					let count = 0;
					for(var key in  this.ticketReasonList[this.loadServiceRequest].categories){
						count++
						if(key == getInlistId){
							this.title = key
							this.title_text = this.ticketReasonList[this.loadServiceRequest].categories[key].title
							this.info_req = this.ticketReasonList[this.loadServiceRequest].categories[key].infomration_req
						}
						
						if(count == Object.keys(this.ticketReasonList[this.loadServiceRequest].categories).length){
							if(!parseInt(this.info_req)){
								this.showDiv = '3'
							}else{
								this.showDiv = '2'
							}
						}
					}
				}else{
					this.showDiv = '3'
				}
            }
		},
        created(){
            if(parseInt(this.$route.params.ticketData) == 16){
				if(this.$route.params.account_id){
					this.ticketRequestFrom = 'deposit'
					this.account_id = this.$route.params.account_id
				}
				if(this.$route.params.page == 'profile'){
					this.ticketRequestFrom = 'profile'
					this.account_id = ''
				}
                
                
                this.method_id = this.$route.params.method_id
				if(this.method_id == 1){
					this.inList_custom_id = 93
				}else if(this.method_id == 2){
					this.inList_custom_id = 95
				}else if(this.method_id == 3){
					this.inList_custom_id = 96
				}else if(this.method_id == 5){
					this.inList_custom_id = 107
				}
                this.enableRequestElement(16)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/request_services.vue